import { createContentPropTypes } from '../../../helpers/content';

const content = {
	header: 'Transactions submitted',
	subHeader:
		'Your transactions have now been submitted – you can see more information about each one below. If you want to check if a transaction’s gone through yet, please click ‘Check payment status.',
	AwaitingAuthTableHeader: 'Awaiting authorisation',
	SubmittedTableHeader: 'Submitted',
	singlePaymentSubHeader:
		'Your transaction has now been submitted. If you want to check if it’s gone through yet, please click ‘Check payment status’',
	accountsButtonLabel: 'Go to your accounts',
	anotherPaymentButtonLabel: 'Make another payment or transfer',
	paymentStatusButtonLabel: 'Check payment status',
	authorisationRequired: 'Authorisation Required',
	softToken: 'Log in to your mobile banking app',
	hardToken: 'Use your security token',
	thirdParty: 'By',
	authorisationNavigation:
		'To authorise payments using your security token, please continue to the ‘Payment status and history’ screen.',
	authorisationNavigationButton: 'Continue to authorise',
	paymentSubmittedHeader: 'Payment Submitted',
	fdpScheduledHeader: 'Transaction Scheduled',
	repeatingTransactionScheduledHeader: 'Repeating Transaction Scheduled',
	transferCompleteHeader: 'Transfer Complete',
	transactionScheduledSubHeader: 'This will be made on ',
	repeatingTransactionScheduledSubHeader: 'The first transaction will be made on ',
	batchHeaderNoAuthRequired: 'submitted',
	batchHeaderAuthRequired: 'awaiting authorisation',
	batchAuthorisationSidebarTitle: 'Authorisation Required',
	batchAuthorisationSoftTokenSidebarBody: 'Please log in to your	mobile banking app to provide authorisation.',
	batchAuthorisationHardTokenSidebarBody:
		'Please continue to the ‘Payment status and history’ screen to provide authorisation.',
	batchAuthorisation3rdPartySidebarBody: 'Awaiting authorisation by ',
	batchAuthorisationSidebarButtonText: 'Continue to authorise',
	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	refLabel: 'Reference',
	dateLabel: 'Date',
	typeLabel: 'Type',
	submissionErrorHeader: 'Payment Failed',
	submissionPendingHeader: 'Pending',
	submissionErrorText: 'We have been unable to process your payment, please resubmit',
	FailedTableHeader: 'Failed',
	PendingTableHeader: 'Pending',
	batchErrorHeader: 'Payments Failed',
	batchPendingHeader: 'Pending',
	batchDailyLimitErrorBody: 'We couldn’t make these payments as your daily limit has been exceeded.',
	sidebarBodyHardToken:
		'Please continue to the ‘Payment status and history’ screen to provide authorisation. Remember that Bacs payments must be authorised by 5.10pm to meet your planned submission and collection dates.',
	sidebarBodySoftToken:
		'Please log in to your mobile banking app to provide authorisation. Remember that Bacs payments must be authorised by 5.10pm to meet your planned submission and settlement dates',
	fileUploadFirstInstruction: 'This uploaded batch payment will need authorised in two stages.',
	fileUploadSecondInstruction: '1. Internet banking',
	fileUploadThirdInstruction: 'Review and confirm the payment details are correct.',
	fileUploadFourthInstruction: '2. Mobile banking app',
	fileUploadFifthInstruction: 'Log in to your mobile banking app to provide final authorisation.',
	fileUploadReviewButton: 'Review and confirm',
	fileUploadTwoStepInstructionHeading: 'Two-step authorisation required',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
